import script from "./TabFieldAIAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./TabFieldAIAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./TabFieldAIAnalysis.vue?vue&type=style&index=0&id=678f46e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-678f46e1"]])

export default __exports__